import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=23964ad6&"
import script from "./LandingView.vue?vue&type=script&lang=js&"
export * from "./LandingView.vue?vue&type=script&lang=js&"
import style0 from "./LandingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports